import {getLogoutRedirectUrl} from '../url'
import React from "react";

export const Logout = () => {
    window.localStorage.removeItem('access_token');
    window.location.assign(getLogoutRedirectUrl());
    return <></>;
};
